import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto brightness-0 invert" />

            <p className="text-gray-400 text-sm leading-relaxed">
              {companyInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/cobertura" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Cobertura
                </Link>
              </li>
              <li>
                <Link to="/marcas" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Marcas
                </Link>
              </li>
              <li>
                <Link to="/modelo" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  Modelo de Distribución
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-emerald-400 mt-1 flex-shrink-0" />
                <a
                  href={companyInfo.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-emerald-400 transition-colors text-sm"
                >
                  {companyInfo.location}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-emerald-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-emerald-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Social & CTA */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-emerald-400">Síguenos</h3>
            <div className="flex space-x-3 mb-6">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-all duration-200"
                aria-label="Facebook">

                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-all duration-200"
                aria-label="Instagram">

                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-emerald-600 transition-all duration-200"
                aria-label="LinkedIn">

                <Linkedin size={20} />
              </a>
            </div>
            <Link
              to="/contacto"
              className="inline-block w-full text-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-medium rounded-lg hover:from-emerald-700 hover:to-teal-700 transition-all duration-200">

              Trabaja con Nosotros
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} {companyInfo.fullName}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>);

};

export default Footer;